import { render, staticRenderFns } from "./ResourceVice.vue?vue&type=template&id=12a1fc2c&"
import script from "./ResourceVice.vue?vue&type=script&lang=js&"
export * from "./ResourceVice.vue?vue&type=script&lang=js&"
import style0 from "./ResourceVice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports